import { isLanguageSpanish } from 'helpers/language'

const englishErrors = {
  digitsOnly: 'Please enter only numbers between 0-9.',
  invalidBirthDate: 'Please enter a valid birth date.',
  invalidCharacters: 'Only this special character is permitted: -',
  invalidCharactersExtra:
    'Only these special characters are permitted: &,/-.#:_‘',
  invalidEmail: 'Please enter a valid email address.',
  invalidConfirmEmail: 'Confirm email address should be same as email address',
  invalidPhoneNumber: 'Please enter a valid phone number.',
  invalidZip: 'Please enter valid zip code.',
  minFourChar: 'This field cannot be less than 4 characters',
  minFiveDigits: 'This field cannot be less than 5 digits',
  minNineChar: 'This field cannot be less than 9 characters',
  recaptchaError: 'Please complete the reCaptcha to submit this form.',
  required: 'This is a required field.'
}

const spanishErrors = {
  digitsOnly: 'Por favor, ingrese solo números del 0 al 9.',
  invalidBirthDate:
    'Por favor ingrese una fecha de nacimiento válida. mm/dd/yyyy.',
  invalidCharacters: 'Solo está permitido este caracter especial: -',
  invalidCharactersExtra:
    'Solo están permitidos estos caracteres especiales: &,/-.#:_‘',
  invalidEmail:
    'Por favor, ingrese una dirección de correo electrónico válida.',
  invalidConfirmEmail:
    'La confirmación de dirección de correo electrónico debe ser igual a la dirección de correo electrónico',
  invalidPhoneNumber: 'Por favor, proporcione un número de teléfono válido',
  invalidZip: 'Por favor, proporcione un código postal válido.',
  minFourChar: 'Este campo requiere un mínimo de 4 caracteres.',
  minFiveDigits: 'Este campo requiere un mínimo de 5 caracteres.',
  minNineChar: 'Este campo requiere un mínimo de 9 caracteres.',
  recaptchaError:
    'Por favor, complete el nuevo Captcha para enviar este formulario.',
  required: 'Este es un campo obligatorio.'
}

const errorMessages = isLanguageSpanish ? spanishErrors : englishErrors

export default errorMessages
